import { useCallback } from 'react'

import { useSegment } from '../../../hooks'
import { useVatDeclaration } from '../context/vatDeclarationContext'

export interface VatDeclarationEventCommonProperties {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  period_settled?: string
  year?: number | null
  type: 'correction' | 'normal'
}

export interface VatDeclarationEventProperties {
  [key: string]: string | number | boolean | undefined
}

export const useTrackVatDeclarationEvent = () => {
  const { track } = useSegment()
  const { periodData, currentCorrection } = useVatDeclaration()

  const trackEvent = useCallback(
    (eventName: string, additionalProperties?: VatDeclarationEventProperties) => {
      const commonProperties: VatDeclarationEventCommonProperties = {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        period_settled: periodData?.periodSettled,
        year: periodData?.year,
        type: (currentCorrection?.correctionNo || 0) > 0 ? 'correction' : 'normal',
      }

      track(eventName, {
        ...commonProperties,
        ...additionalProperties,
      })
    },
    [track, periodData, currentCorrection],
  )

  return trackEvent
}
